import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper';

import styles from './logo_slide.module.css';
import './logo_slide.css';

const LogoSlide = () => {
  const { innerWidth } = window;

  return (
    <>
      <Swiper
        className={[styles.logoSwiper, 'logoSwiper'].join(' ')}
        modules={[FreeMode, Autoplay]}
        allowTouchMove={false}
        loop={true}
        loopFillGroupWithBlank={true}
        centeredSlides={true}
        freeMode={false}
        spaceBetween={30}
        slidesPerView={innerWidth > 1200 ? 6 : 5}
        speed={5000}
        grabCursor={false}
        autoplay={{
          delay: -10,
          disableOnInteraction: false,
          waitForTransition: false,
          stopOnLastSlide: false,
          pauseOnMouseEnter: true,
        }}
      >
        {Array(15)
          .fill()
          .map((i) => i + 1)
          .map((o, index) => {
            return (
              <SwiperSlide key={index}>
                <img
                  src={
                    process.env.PUBLIC_URL + `imgs/main/logo/${index + 1}.png`
                  }
                  alt={index}
                />
              </SwiperSlide>
            );
          })}
      </Swiper>

      <div className={styles.logoContainer}>
        {Array(15)
          .fill()
          .map((m, index) => (
            <img
              key={index}
              src={process.env.PUBLIC_URL + `imgs/main/logo/${index + 1}.png`}
              alt={index}
            />
          ))}
      </div>
    </>
  );
};

export default LogoSlide;
